import React from 'react';
import Select from 'react-select';

const InformacionIglesia = ({ formData, handleChange, denominacionOptions }) => {
  return (
    <div className="informacion-iglesia">
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      }}>
        <span style={{
          backgroundColor: '#ddd6fe',
          color: '#7c3aed',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '0.75rem',
          fontWeight: 'bold',
          fontSize: '0.875rem'
        }}>2</span>
        Información de tu Iglesia
      </h2>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem'
      }}>
        <div>
          <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Nombre de la Iglesia</label>
          <input
            type="text"
            name="nombreIglesia"
            value={formData.nombreIglesia}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              boxSizing: 'border-box'
            }}
            placeholder="Nombre de tu iglesia"
          />
        </div>
        
        <div>
          <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Pastor o Lider</label>
          <input
            type="text"
            name="pastorIglesia"
            value={formData.pastorIglesia}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              boxSizing: 'border-box'
            }}
            placeholder="Nombre del pastor"
          />
        </div>
      </div>

      <div style={{
        marginTop: '2rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem'
      }}>
        <div>
          <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Ciudad</label>
          <input
            type="text"
            name="ciudadIglesia"
            value={formData.ciudadIglesia}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              boxSizing: 'border-box'
            }}
            placeholder="Ciudad de tu iglesia"
          />
        </div>

        <div>
          <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Denominación</label>
          <Select
            value={denominacionOptions.find(option => option.value === formData.denominacion)}
            onChange={(selectedOption) => {
              const event = {
                target: {
                  name: 'denominacion',
                  value: selectedOption ? selectedOption.value : ''
                }
              };
              handleChange(event);
            }}
            options={denominacionOptions}
            placeholder="Selecciona una opción"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                minHeight: '52px',
                fontSize: '16px',
                borderColor: '#d1d5db',
                '&:hover': { borderColor: '#9ca3af' }
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                color: state.isSelected ? 'white' : '#1f2937',
                fontWeight: state.isSelected ? 500 : 400,
                '&:hover': {
                  backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                  color: state.isSelected ? 'white' : '#1f2937'
                }
              })
            }}
          />
        </div>
      </div>
      {/* Espacio adicional para dropdown de denominación */}
      <div style={{ marginBottom: '250px' }}></div>
    </div>
  );
};

export default InformacionIglesia;
